import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appPopUp]'
})
export class PopUpDirective implements OnInit {

  popUpContainer: HTMLElement;
  pressed!: boolean;
  width!: number;
  height!: number;
  draggableEle!: Element;
  mouseMoveListener!: () => void;
  mouseUpListener!: () => void;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) {
    this.popUpContainer = this.el.nativeElement;
  }

  // Get conatiner details on init and listen to mouse events
  ngOnInit(): void {
    this.renderer.addClass(this.popUpContainer, 'pop-up-container');
    const elementList = this.popUpContainer.getElementsByClassName('pop-up-draggable');
    const content = this.popUpContainer.getElementsByClassName('pop-up-content');
    if (!!this.popUpContainer && elementList.length && content.length) {
      this.draggableEle = elementList[0];
      this.renderer.listen(this.draggableEle, 'mousedown', this.onMouseDown);
    }
  }

  // On mouse click
  onMouseDown = () => {
    this.pressed = true;
    this.width = this.popUpContainer.clientWidth;
    this.height = this.popUpContainer.clientHeight;

    // Attach the listeners to `document`
    this.mouseMoveListener = this.renderer.listen('document', 'mousemove', i => this.onMouseMove(i));
    this.mouseUpListener = this.renderer.listen('document', 'mouseup', i => this.onMouseUp());
  }

  // Update on move movement
  onMouseMove = (event: MouseEvent) => {
    if (this.pressed) {
      this.renderer.setStyle(this.popUpContainer, 'top', `${event.pageY + ((this.height / 2) - 20)}px`);
      this.renderer.setStyle(this.popUpContainer, 'left', `${this.draggableEle.clientLeft + event.clientX}px`);
    }
  }

  // On unclick
  onMouseUp = () => {
    if (this.pressed) {
      this.pressed = false;

      // Remove the handlers of `mousemove` and `mouseup`    
      this.mouseMoveListener();
      this.mouseUpListener();
    }
  }

}

